module.exports = __webpack_public_path__ + "static/media/sideshow-bob.f4fc2946.png";